<template>
  <!-- 支付 -->
  <div>
    <Header></Header>
    <div class="background">
      <div class="course_system" v-for="(list,index) in lists" :key="index">
        <!-- 微导航 -->
        <div class="wnav">
          <span>课程体系</span> >
          <span>全部课程</span> >
          <span>课程详情</span> >
          <span class="gengduo">{{list.name}}</span>
        </div>
        <div class="title">{{video_name}}</div>
        <div class="body">
          <div class="video" v-if="off">
            <video
              id="myVideo"
              controls
              controlslist="nodownload noremote footbar"
              autoplay
              :poster="image"
              width="850"
              height="500"
            >
              <source :src="`${video}#t=${s}`" type="video/mp4" />Your browser does not support the video tag.
            </video>
          </div>
          <!-- <div v-else>
            <embed :poster="list.image" height="600" width="850" :src="video" />
          </div>-->
          <div class="right">
            <div class="right-top">
              <div class="lecturer">
                <div class="js">课程讲师</div>
                <div class="name" @click="gotdetails(list.teacher_id)">
                  <img :src="list.teacher_data.avatar" alt />
                  <div class="center">
                    <span class="center-name">{{list.teacher_data.nickname}}</span>
                    <span class="center-c">{{list.teacher_data.the_title}}</span>
                  </div>
                  <span class="jiantou">
                    <img src="../assets/img/in.png" alt />
                  </span>
                </div>
              </div>
            </div>
            <el-collapse class="right-center">
              <el-collapse-item v-for="(list1,index) in list.chapter_list" :key="index">
                <template slot="title">
                  <div class="Catalog">{{list1.name}}</div>
                </template>
                <ul>
                  <li @click="gobf(list2)" v-for="(list2,index) in list1.video_list" :key="index">
                    <span>{{list2.name}}</span>
                    <span>{{list2.playtime_time}}</span>
                  </li>
                </ul>
              </el-collapse-item>
            </el-collapse>
            <!-- 相关推荐 -->
            <div class="right-bottom">
              <div class="related">相关推荐</div>
              <div
                class="related-list"
                @click="godetails(list2.id)"
                v-for="(list2,index) in list.xg_list"
                :key="index"
              >
              <div>
                <img :src="list2.image" alt />
              </div>
               
                <div>
                  <div class="name">{{list2.name}}</div>
                  <div class="lecturer1">讲师：{{list2.teacher_name}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "./header";
import Footer from "./footer";

export default {
  name: "course_system",
  data() {
    return {
      id: "",
      lists: [],
      arrs: [],
      video_lists: [],
      i: false,
      s: "0",
      video: "",
      off: true,
      video_name: "",
      coursevideo_id: "",
      video_id: "",
      list: [],
      image: "",
      video_id1: "",
      newtime: ""
    };
  },
  created() {
    this.id = this.$route.query.id;
  },
  methods: {
    // 课程详情
    async course_detail() {
      var id = JSON.parse(sessionStorage.getItem("data"));
      await this.$service.home
        .course_detail({ course_id: this.id, uid: id.id, pc: 1 })
        .then(res => {
          if (res.data.code == 200) {
            // 视频标题
            this.video_name = res.data.content.video_name;
            this.lists.push(res.data.content);
            this.video = res.data.content.video_address;
            this.video_id1 = res.data.content.video_id;
            // 上次看到的时间
            this.s = res.data.content.video_miao;
            // 上次看到的背景图片
            this.image = res.data.content.video_image;
            this.video_lists = res.data.content.chapter_list;
            this.video_lists.map((e, i) => {
              e.video_list.map((item, i) => {
                this.arrs.push(item);
              });
            });
            // 判断有没有播放记录(没有播放记录执行一下代码)
            if (res.data.content.video_address == ``) {
              console.log(this.arrs);
              this.video = this.arrs[0].videofile;
              this.image = this.arrs[0].image;
              this.s = 0;
              setTimeout(() => {
                this.off = true;
                this.video_name = this.arrs[0].name;
              }, 1);
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
      if (this.$route.query.videofile) {
        this.video = this.$route.query.videofile;
        this.s = 0;
        this.image = this.$route.query.image;
        this.video_id1 = this.$route.query.video_id;
        this.video_name = this.$route.query.name;
      }
    },

    // 点击播放请求
    // async bofang(i, list) {
    //   this.list = list;
    //   this.i = !i;
    //   if (this.i == true) {
    //     // 播放前请求
    //     var id = JSON.parse(sessionStorage.getItem("data"));
    //     await this.$service.home
    //       .pay_count({ uid: id.id, id: this.id })
    //       .then(res => {
    //         // console.log(res);
    //         if (res.data.code == 200) {
    //         }
    //       })
    //       .catch(err => {
    //         console.log(err);
    //       });
    //   } else {
    //     // 播放停止后请求
    //     if (this.coursevideo_id == ``) {
    //       this.video_id = list.video_id;
    //     } else {
    //       this.video_id = this.coursevideo_id;
    //     }
    //     // 获取播放时间
    //     var Video = document.getElementById("myVideo");
    //     var timeDisplay = Math.floor(Video.currentTime);
    //     var id = JSON.parse(sessionStorage.getItem("data"));
    //     await this.$service.home
    //       .pay_time({
    //         uid: id.id,
    //         coursevideo_id: this.video_id,
    //         lastminute: timeDisplay
    //       })
    //       .then(res => {
    //         // console.log(res)
    //       })
    //       .catch(err => {
    //         console.log(err);
    //       });
    //   }
    // },
    bofang() {
      setTimeout(() => {
        let video = document.getElementById("myVideo");
        let _this = this;
        //监听播放开始
        video.addEventListener("play", function() {
          console.log("开始播放");
          // 播放前请求
          var id = JSON.parse(sessionStorage.getItem("data"));
          _this.$service.home
            .pay_count({ uid: id.id, id: _this.id })
            .then(res => {
              console.log(res);
              if (res.data.code == 200) {
              }
            })
            .catch(err => {
              console.log(err);
            });
        });
        //监听播放暂停
        video.addEventListener("pause", function() {
          console.log("播放暂停");
          // 播放停止后请求
          if (_this.coursevideo_id == ``) {
            _this.video_id = _this.video_id1;
          } else {
            _this.video_id = _this.coursevideo_id;
          }
          // 获取播放时间
          // var Video = document.getElementById("myVideo");
          var timeDisplay = _this.newtime;
          var id = JSON.parse(sessionStorage.getItem("data"));
          _this.$service.home
            .pay_time({
              uid: id.id,
              coursevideo_id: _this.video_id,
              lastminute: timeDisplay
            })
            .then(res => {
              console.log(res);
            })
            .catch(err => {
              console.log(err);
            });
        });
        //监听播放结束
        video.addEventListener("ended", function() {
          console.log("播放结束");
        });
        // 使用事件监听方式捕捉事件
        video.addEventListener(
          "timeupdate",
          function() {
            var timeDisplay;
            //用秒数来显示当前播放进度
            timeDisplay = Math.floor(video.currentTime);
            // console.log(timeDisplay);
            _this.newtime = timeDisplay;
          },
          false
        );
      }, 1000);
    },
    // 选择播放
    gobf(list) {
      console.log(list);
      this.coursevideo_id = list.id;
      this.image = list.image;
      this.off = false;
      this.video = list.videofile;
      this.s = 0;
      this.list = list;
      this.bofang();
      setTimeout(() => {
        this.off = true;
        this.video_name = list.name;
      }, 1);
    },
    // 讲师跳转
    gotdetails(id) {
      // console.log(id);
      this.$router.push({
        path: "topic_details",
        query: {
          id: id
        }
      });
    },
    // 相关推荐
    godetails(id) {
      this.$router.push({
        path: "/details",
        query: {
          id: id
        }
      });
    }
  },

  components: {
    Header,
    Footer
  },
  beforeDestroy() {
    let _this = this;
    // 播放停止后请求
    if (_this.coursevideo_id == ``) {
      _this.video_id = _this.video_id1;
    } else {
      _this.video_id = _this.coursevideo_id;
    }
    // 获取播放时间
    var timeDisplay = _this.newtime;
    var id = JSON.parse(sessionStorage.getItem("data"));
    _this.$service.home
      .pay_time({
        uid: id.id,
        coursevideo_id: _this.video_id,
        lastminute: timeDisplay
      })
      .then(res => {
        console.log(res);
      })
      .catch(err => {
        console.log(err);
      });
  },
  mounted() {
    this.course_detail();
    this.bofang();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
video::-internal-media-controls-download-button {
  display: none;
}

video::-webkit-media-controls-enclosure {
  overflow: hidden;
}

video::-webkit-media-controls-panel {
  width: calc(100% + 50px);
}
/* 微导航 */
.background .course_system {
  width: 1200px;
  margin: 0 auto;
}
.wnav {
  height: 30px;
  line-height: 40px;
  font-size: 14px;
  margin-bottom: 10px;
}
.wnav span.gengduo {
  color: rgba(136, 136, 136, 1);
}
.course_system .title {
  min-width: 374px;
  height: 40px;
  font-size: 28px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  line-height: 40px;
  margin-bottom: 12px;
}
.course_system .body {
  display: flex;
  justify-content: space-between;
}
.course_system .body .video {
  width: 860px;
  height: 776px;
}
.course_system .body .right {
  width: 324px;
  border-radius: 3px;
  border: 1px solid rgba(237, 237, 237, 1);
}
/* 右边上 */
.right .right-top {
  width: 324px;
  height: 146px;
  background: rgba(255, 255, 255, 1);
  border-radius: 3px;
  border: 1px solid rgba(237, 237, 237, 1);
  margin-bottom: 16px;
}
.right .right-top .lecturer {
  width: 280px;
  height: 100px;
  margin: 0 auto;
  position: relative;
  top: 50%; /*偏移*/
  transform: translateY(-50%);
}
.right .right-top .lecturer .js {
  font-size: 16px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  margin-bottom: 20px;
  border-left: 3px solid #1775ef;
  padding-left: 5px;
}
.right .right-top .lecturer .name {
  display: flex;
}
.right .right-top .lecturer .name .jiantou img {
  margin-left: 108px;
  margin-top: 18px;
  width: 10px;
  height: 10px;
}
.right .right-top .lecturer .name img {
  width: 54px;
  height: 54px;
  border-radius: 50%;
  margin-right: 10px;
}
.right .right-top .lecturer .name .center {
  display: inline-flex;
  flex-direction: column;
}
.right .right-top .lecturer .name .center .center-name {
  font-size: 18px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 25px;
}
.right .right-top .lecturer .name .center .center-c {
  font-size: 14px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 36px;
}
/* 右边中 */
.right .right-center {
  width: 324px;
  background: rgba(255, 255, 255, 1);
  border-radius: 3px;
  margin-bottom: 16px;
}
.right .right-center .Catalog {
  width: 284px;
  margin: 0 auto;
  font-size: 16px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  margin-left: 20px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}
.right .right-center ul {
  padding: 0;
}
.right .right-center ul li {
  height: 30px;
  width: 260px;
  display: flex;
  justify-content: space-between;
  padding-bottom: 20px;
  font-size: 14px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 40px;
  margin: 0 auto;
}
.right .right-center ul li span:nth-child(1) {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.right .right-center ul li:hover {
  background: rgba(23, 117, 239, 0.1);
}
/* 右边下 */
.right .right-bottom {
  width: 324px;
  height: auto;
  background: rgba(255, 255, 255, 1);
  border-radius: 3px;
  border: 1px solid rgba(237, 237, 237, 1);
}
.right .right-bottom .related {
  width: 280px;
  font-size: 16px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  border-left: 3px solid #1775ef;
  padding-left: 5px;
  margin: 0 auto;
  margin-bottom: 16px;
  margin-top: 20px;
}
.right .right-bottom .related-list {
  display: flex;
  width: 280px;
  margin: 0 auto;
  margin-bottom: 16px;

}
.right .right-bottom .related-list img {
  width: 110px;
  height: 73px;
  border-radius: 6px;
  margin-right: 10px;
}
.right .right-bottom .related-list .name {
  font-size: 16px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 22px;
  margin-bottom: 10px;
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; /*控制可显示几行文本*/
}
.right .right-bottom .related-list .lecturer1 {
  font-size: 12px;
  font-weight: 500;
  color: rgba(136, 136, 136, 1);
  line-height: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/course_system.vue